// report titles
const REPORT_PLAYER_ID = 'Player ID';
const REPORT_EXT_PLAYER_ID = 'External Player ID';
const REPORT_VIP_LEVEL = 'VIP Level';
const REPORT_PARTNER = 'Partner';
const REPORT_PARTNER_ID = 'Partner ID';
const REPORT_CATEGORIES = 'Categories';
const REPORT_SKIN_ID = 'Skin ID';
const REPORT_PARTNER_SKIN = 'Partner - Skin';
const REPORT_USERNAME = 'Username';
const REPORT_EMAIL = 'Email';
const REPORT_NIKNAME = 'Nickname';
const REPORT_FIRST_NAME = 'First Name';
const REPORT_LAST_NAME = 'Last Name';
const REPORT_COUNTRY_CURRENCY = 'Country - Currency';
const REPORT_CURRENCY = 'Currency';
const REPORT_FIRST_ACTIVITY = 'First Activity';
const REPORT_LAST_ACTIVITY = 'Last Activity';
const REPORT_LAST_KNOWN_IP = 'Last Known IP';
const REPORT_LIFETIME_BET = 'Lifetime Bet';
const REPORT_LIFETIME_WIN = 'Lifetime Win';
const REPORT_LIFETIME_GGR = 'Lifetime GGR';
const REPORT_STATE = 'State';
const REPORT_CITY = 'City';
const REPORT_REAL_BONUS_BALANCE = 'Real bonus balance';
const REPORT_REAL_BONUS_AWARDED = 'Real bonus awarded';
const REPORT_REAL_BONUS_EXPIRED = 'Real bonus expired';
const REPORT_SESSION_ID = 'Session ID';
const REPORT_SKIN = 'Skin';
const REPORT_PROVIDER = 'Provider';
const REPORT_GAME = 'Game';
const REPORT_GAME_NAME = 'Game Name';
const REPORT_GAME_ID = 'Game ID';
const REPORT_GAME_PROVIDER = 'Game Provider';
const REPORT_DEVICE = 'Device';
const REPORT_SOURCE = 'Source';
const REPORT_TYPE = 'Type';
const REPORT_STATUS = 'Status';
const REPORT_BETS = 'Bets';
const REPORT_BET_AMOUNT = 'Bet Amount';
const REPORT_GGR = 'GGR';
const REPORT_GGR_EUR = 'GGR in EUR';
const REPORT_RATE = 'Rate';
const REPORT_WRB = 'WRB';
const REPORT_BONUS_USED = 'Bonus Used';
const REPORT_AAMS_TICKET_ID = 'AAMS Ticket ID';
const REPORT_TP_SESSION_ID = 'TP Session ID';
const REPORT_IP = 'IP';
const REPORT_SESSION_START = 'Session Start';
const REPORT_SESSION_END = 'Session End';
const REPORT_ROUNDS = 'Rounds';
const REPORT_BET = 'Bet';
const REPORT_WIN = 'Win';
const REPORT_BONUS_BET = 'Bonus Bet';
const REPORT_BONUS_WIN = 'Bonus Win';
const REPORT_BINGO_FEE = 'Bingo Fee';
const REPORT_JP_CONTRIBUTION = 'JP Contribution';
const REPORT_JP_WIN = 'JP Win';
const REPORT_SESSIONS = 'Sessions';
const REPORT_UAP = 'UAP';
const REPORT_RAKE = 'Rake';
const REPORT_TRANSACTION_ID = 'Transaction ID';
const REPORT_TP_TRX_ID = 'TP Trx ID';
const REPORT_ROUND_ID = 'Round ID';
const REPORT_AMOUNT = 'Amount';
const REPORT_ORIGINAL_AMOUNT = 'Original Amount';
const REPORT_BALANCE = 'Balance';
const REPORT_SESSION_TYPE = 'Session Type';
const REPORT_CREATED = 'Created';
const REPORT_FINISHED = 'Finished';
const REPORT_WIN_TYPE = 'Win Type';
const REPORT_COUNTRY = 'Country';
const REPORT_BLOCKED_PROVIDERS = 'Blocked Providers';
const REPORT_LAST_REAL_BONUS = 'Last real bonus';
const REPORT_HAND_DETAILS = 'Hand Details';
const REPORT_CAMPAIN_ID = 'Campaign ID';
const REPORT_CAMPAIN_NAME = 'Campaign name';
const REPORT_AMOUNT_AWARDED = 'Amount awarded';
const REPORT_REMAINING_AMOUNT = 'Remaining amount';
const REPORT_REMAINING_WAGERING = 'Remaining wagering';
const REPORT_EXPIRATION = 'Expiration';
const REPORT_ACTIVE = 'Active';
const REPORT_SLOT = 'Slot';
const REPORT_GAME_PROVIDER_ID = 'Provider Game ID';
const REPORT_AAMS_GAME_ID = 'AAMS Game ID';
const REPORT_AAMS_GAME_TYPE = 'AAMS Game Type';
const REPORT_PGDA_831 = 'PGDA 831';
const REPORT_NOTES = 'Note';

// column values
const COLUMN_IS_SLOT = 'is_slot';
const COLUMN_PLAYER_ID = 'player_id';
const COLUMN_EXT_PLAYER_ID = 'external_player_id';
const COLUMN_VIP_LEVEL = 'vip_level_name';
const COLUMN_PARTNER = 'partner';
const COLUMN_PARTNER_ID = 'partner_id';
const COLUMN_SKIN_ID = 'skin_id';
const COLUMN_USERNAME = 'user_name';
const COLUMN_EMAIL = 'email';
const COLUMN_NIKNAME = 'poker_user_name';
const COLUMN_FIRST_NAME = 'first_name';
const COLUMN_LAST_NAME = 'last_name';
const COLUMN_COUNTRY_CURRENCY = 'currency';
const COLUMN_CURRENCY = 'currency';
const COLUMN_FIRST_ACTIVITY = 'first_activity';
const COLUMN_LAST_ACTIVITY = 'last_activity';
const COLUMN_LAST_KNOWN_IP = 'last_known_ip';
const COLUMN_LIFETIME_BET = 'bet';
const COLUMN_LIFETIME_WIN = 'win';
const COLUMN_LIFETIME_GGR = 'ggr';
const COLUMN_STATE = 'country';
const COLUMN_CITY = 'city';
const COLUMN_CATEGORY = 'category';
const COLUMN_REAL_BONUS_BALANCE = 'balance';
const COLUMN_REAL_BONUS_AWARDED = 'awarded';
const COLUMN_REAL_BONUS_EXPIRED = 'expired';
const COLUMN_SESSION_ID = 'session_id';
const COLUMN_SKIN = 'skin';
const COLUMN_GAME_PROVIDER_NAME = 'game_provider_name';
const COLUMN_PROVIDER = 'provider';
const COLUMN_GAME = 'game_name';
const COLUMN_GAME_ID = 'game_id';
const COLUMN_DEVICE = 'device';
const COLUMN_SOURCE = 'widget';
const COLUMN_TYPE = 'session_type';
const COLUMN_STATUS = 'session_status';
const COLUMN_NRHANDS = 'nrhands';
const COLUMN_BET_AMOUNT = 'bet';
const COLUMN_GGR = 'ggr';
const COLUMN_GGR_EUR = 'ggr_eur';
const COLUMN_RATE = 'rate';
const COLUMN_WRB = 'wrb';
const COLUMN_BONUS_USED = 'bonus_used';
const COLUMN_PARTNER_SKIN = 'partner_skin';
const COLUMN_AAMS_TICKET_ID = 'aams_ticket_id';
const COLUMN_TP_SESSION_ID = 'thirdparty_session_id';
const COLUMN_IP = 'ip';
const COLUMN_SESSION_START = 'session_start';
const COLUMN_SESSION_END = 'session_end';
const COLUMN_BONUS_BET = 'bonus_bet';
const COLUMN_BONUS_WIN = 'bonus_win';
const COLUMN_BINGO_FEE = 'bingo_fee';
const COLUMN_JP_CONTRIBUTION = 'jp_contribution';
const COLUMN_JP_WIN = 'jp_win';
const COLUMN_SESSIONS = 'sessions';
const COLUMN_UAP = 'uap';
const COLUMN_RAKE = 'rake';
const COLUMN_TRANSACTION_ID = 'transaction_id';
const COLUMN_THIRDPARTY_TRX_ID = 'thirdparty_trx_id';
const COLUMN_ROUND_ID = 'round_id';
const COLUMN_STATUS_NAME = 'status_name';
const COLUMN_AMOUNT = 'amount';
const COLUMN_ORIG_AMOUNT = 'orig_amount';
const COLUMN_BALANCE = 'balance';
const COLUMN_TYPE_NAME = 'type_name';
const COLUMN_WALLET = 'wallet';
const COLUMN_CREATETIME = 'createtime';
const COLUMN_CREATE_TIME = 'create_time';
const COLUMN_FINISHTIME = 'finishtime';
const COLUMN_CONTEXT = 'context';
const COLUMN_COUNTRY = 'country';
const COLUMN_BLOCKED_PROVIDERS = 'blocked_providers';
const COLUMN_LAST_REAL_BONUS = 'last_real-bonus';
const COLUMN_HAND_DETAILS = 'hand_details';
const COLUMN_CAMPAIN_ID = 'campaign_id';
const COLUMN_NAME = 'name';
const COLUMN_AMOUNT_AWARDED = 'amount_awarded';
const COLUMN_REMAINING_AMOUNT = 'remaining_amount';
const COLUMN_REMAINING_WAGERING = 'remaining_wagering';
const COLUMN_EXPIRATION = 'expiration';
const COLUMN_ACTIVE = 'active';
const COLUMN_GAME_NAME = 'game_name';
const COLUMN_GAME_PROVIDER = 'provider_name';
const COLUMN_PROVIDER_GAME_ID_DESKTOP = 'provider_game_id_desktop';
const COLUMN_AAMS_GAME_ID = 'aams_game_id_desktop';
const COLUMN_AAMS_GAME_TYPE = 'aams_game_id_type';
const COLUMN_CHECKSUM_RESULT = 'checksum_result';
const COLUMN_NOTES = 'notes';

export const reportConstants = {
	REPORT_PLAYER_ID,
	REPORT_EXT_PLAYER_ID,
	REPORT_VIP_LEVEL,
	REPORT_PARTNER,
	REPORT_PARTNER_ID,
	REPORT_SKIN_ID,
	REPORT_USERNAME,
	REPORT_EMAIL,
	REPORT_NIKNAME,
	REPORT_FIRST_NAME,
	REPORT_LAST_NAME,
	REPORT_COUNTRY_CURRENCY,
	REPORT_FIRST_ACTIVITY,
	REPORT_LAST_ACTIVITY,
	REPORT_GAME_NAME,
	REPORT_LIFETIME_BET,
	REPORT_LIFETIME_WIN,
	REPORT_LIFETIME_GGR,
	REPORT_STATE,
	REPORT_CITY,
	REPORT_CURRENCY,
	REPORT_REAL_BONUS_AWARDED,
	REPORT_REAL_BONUS_BALANCE,
	REPORT_REAL_BONUS_EXPIRED,
	REPORT_PARTNER_SKIN,
	REPORT_LAST_KNOWN_IP,
	REPORT_SESSION_ID,
	REPORT_SKIN,
	REPORT_PROVIDER,
	REPORT_GAME,
	REPORT_GAME_ID,
	REPORT_DEVICE,
	REPORT_SOURCE,
	REPORT_SLOT,
	REPORT_TYPE,
	REPORT_STATUS,
	REPORT_BETS,
	REPORT_BET_AMOUNT,
	REPORT_GGR,
	REPORT_GGR_EUR,
	REPORT_RATE,
	REPORT_WRB,
	REPORT_BONUS_USED,
	REPORT_AAMS_TICKET_ID,
	REPORT_TP_SESSION_ID,
	REPORT_GAME_PROVIDER_ID,
	REPORT_AAMS_GAME_ID,
	REPORT_AAMS_GAME_TYPE,
	REPORT_IP,
	REPORT_SESSION_START,
	REPORT_SESSION_END,
	REPORT_ROUNDS,
	REPORT_BET,
	REPORT_WIN,
	REPORT_BONUS_BET,
	REPORT_BONUS_WIN,
	REPORT_BINGO_FEE,
	REPORT_JP_CONTRIBUTION,
	REPORT_JP_WIN,
	REPORT_SESSIONS,
	REPORT_CAMPAIN_ID,
	REPORT_UAP,
	REPORT_RAKE,
	REPORT_GAME_PROVIDER,
	REPORT_TRANSACTION_ID,
	REPORT_TP_TRX_ID,
	REPORT_ROUND_ID,
	REPORT_AMOUNT,
	REPORT_NOTES,
	REPORT_ORIGINAL_AMOUNT,
	REPORT_BALANCE,
	REPORT_SESSION_TYPE,
	REPORT_CREATED,
	REPORT_FINISHED,
	REPORT_WIN_TYPE,
	REPORT_COUNTRY,
	REPORT_BLOCKED_PROVIDERS,
	REPORT_LAST_REAL_BONUS,
	REPORT_HAND_DETAILS,
	REPORT_CATEGORIES,
	REPORT_CAMPAIN_NAME,
	REPORT_AMOUNT_AWARDED,
	REPORT_REMAINING_AMOUNT,
	REPORT_REMAINING_WAGERING,
	REPORT_EXPIRATION,
	REPORT_PGDA_831,
	REPORT_ACTIVE,

	// columns
	COLUMN_PLAYER_ID,
	COLUMN_EXT_PLAYER_ID,
	COLUMN_VIP_LEVEL,
	COLUMN_PARTNER,
	COLUMN_USERNAME,
	COLUMN_EMAIL,
	COLUMN_NIKNAME,
	COLUMN_FIRST_NAME,
	COLUMN_LAST_NAME,
	COLUMN_COUNTRY_CURRENCY,
	COLUMN_FIRST_ACTIVITY,
	COLUMN_LAST_ACTIVITY,
	COLUMN_LIFETIME_BET,
	COLUMN_LIFETIME_WIN,
	COLUMN_LIFETIME_GGR,
	COLUMN_STATE,
	COLUMN_CITY,
	COLUMN_CURRENCY,
	COLUMN_REAL_BONUS_BALANCE,
	COLUMN_REAL_BONUS_AWARDED,
	COLUMN_REAL_BONUS_EXPIRED,
	COLUMN_LAST_KNOWN_IP,
	COLUMN_SESSION_ID,
	COLUMN_SKIN,
	COLUMN_PROVIDER,
	COLUMN_GAME,
	COLUMN_DEVICE,
	COLUMN_SOURCE,
	COLUMN_TYPE,
	COLUMN_STATUS,
	COLUMN_NRHANDS,
	COLUMN_BET_AMOUNT,
	COLUMN_GGR,
	COLUMN_GGR_EUR,
	COLUMN_RATE,
	COLUMN_WRB,
	COLUMN_BONUS_USED,
	COLUMN_AAMS_TICKET_ID,
	COLUMN_TP_SESSION_ID,
	COLUMN_IP,
	COLUMN_SESSION_START,
	COLUMN_SESSION_END,
	COLUMN_BONUS_BET,
	COLUMN_BONUS_WIN,
	COLUMN_BINGO_FEE,
	COLUMN_JP_CONTRIBUTION,
	COLUMN_JP_WIN,
	COLUMN_SESSIONS,
	COLUMN_UAP,
	COLUMN_RAKE,
	COLUMN_TRANSACTION_ID,
	COLUMN_THIRDPARTY_TRX_ID,
	COLUMN_ROUND_ID,
	COLUMN_STATUS_NAME,
	COLUMN_AMOUNT,
	COLUMN_ORIG_AMOUNT,
	COLUMN_BALANCE,
	COLUMN_TYPE_NAME,
	COLUMN_WALLET,
	COLUMN_CREATETIME,
	COLUMN_FINISHTIME,
	COLUMN_CONTEXT,
	COLUMN_GAME_PROVIDER_NAME,
	COLUMN_COUNTRY,
	COLUMN_BLOCKED_PROVIDERS,
	COLUMN_LAST_REAL_BONUS,
	COLUMN_HAND_DETAILS,
	COLUMN_PARTNER_SKIN,
	COLUMN_PARTNER_ID,
	COLUMN_SKIN_ID,
	COLUMN_GAME_ID,
	COLUMN_CATEGORY,
	COLUMN_CAMPAIN_ID,
	COLUMN_NAME,
	COLUMN_AMOUNT_AWARDED,
	COLUMN_REMAINING_AMOUNT,
	COLUMN_REMAINING_WAGERING,
	COLUMN_EXPIRATION,
	COLUMN_CREATE_TIME,
	COLUMN_ACTIVE,
	COLUMN_GAME_NAME,
	COLUMN_GAME_PROVIDER,
	COLUMN_IS_SLOT,
	COLUMN_PROVIDER_GAME_ID_DESKTOP,
	COLUMN_AAMS_GAME_ID,
	COLUMN_AAMS_GAME_TYPE,
	COLUMN_CHECKSUM_RESULT,
	COLUMN_NOTES,
};
